import { createStore, combineReducers, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
// reducers
import reducerRouter from './reducers/reducer_router'
import reducerAjax from './reducers/reducer_ajax'
import reducerGui from './reducers/reducer_gui'
import reducerAudio from './reducers/reducer_audio'
import reducerVideo from './reducers/reducer_video'

// combined reducers
const rootReducer = combineReducers({
  reducerRouter,
  reducerAjax,
  reducerGui,
  reducerAudio,
  reducerVideo,
})
// create store
export const store = createStore(rootReducer, composeWithDevTools()) 